import { render } from "./custom.scanner.vue?vue&type=template&id=8615c712"
import script from "./custom.scanner.vue?vue&type=script&lang=js"
export * from "./custom.scanner.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__